<template>
  <v-form>
    <v-row :class="$style.fixUploadRowWidth">
      <template>
        <v-file-input
          v-model="additionalFilesGlobal"
          class="itemDivsFileUpload"
          outlined
          multiple
          small-chip
          :max="3"
          show-size
          truncate-length="240"
          prepend-icon=""
          prepend-inner-icon="mdi-paperclip"
          :counter-string="
            $tc('hubspot.formField.fileUploadMaxFiles', filesToSend?.length, {
              maxFiles: filesToSend?.length,
            })
          "
          :label="
            $tc('hubspot.formField.fileUploadMaxFiles', filesToSend?.length, {
              maxFiles: filesToSend?.length,
            })
          "
          :error-messages="additionalFilesGlobalError"
          @change="fileAdded"
          @click:clear="clearData()"
        >
          <template #selection="{ text, index }" style="flex-direction: column">
            <div style="width: 100%">
              <v-chip :key="index" style="margin-top: 12px" close @click:close="removeItem(index)">
                {{ text }}
              </v-chip>
            </div>
          </template>
        </v-file-input>
      </template>
    </v-row>
    <v-row>
      <v-col>
        <v-textarea
          v-model="ticketDescription"
          outlined
          class="requiredHubspotFormInput"
          :label="$t('hubspot.formField.ticketDescription')"
          :error-messages="ticketDescriptionErrors"
        ></v-textarea>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import FormValidationMixin from '@/js/components/Forms/mixins/form-validation-mixin.js'
import { required, maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'DescriptionForm',
  mixins: [FormValidationMixin],
  data() {
    return {
      maxFiles: 3,
      ticketDescription: '',
      additionalFilesGlobal: [],
      previousFiles: [],
    }
  },
  validations: {
    ticketDescription: {
      required,
    },
    additionalFilesGlobal: {
      maxLength: maxLength(3),
    },
  },
  computed: {
    additionalFilesGlobalError() {
      return this.formErrorHelper('additionalFilesGlobal', [this.maxFilesError(3)])
    },
    ticketDescriptionErrors() {
      return this.formErrorHelper('ticketDescription', [this.requiredError])
    },
    filesToSend() {
      return this.additionalFilesGlobal?.slice(0, this.maxFiles)
    },
    postData() {
      const data = {
        fields: [
          {
            objectTypeId: '0-5',
            name: 'content',
            value: this.ticketDescription,
          },
        ],
      }
      var files = []
      this.filesToSend.forEach((file, i) => {
        // IMPORTANT!!
        var fileObject = {
          key: 'multipleGlobalUploadField_' + i, // IF THIS VALUE IS MODIFIED, YOU MUST (!!!) ALSO CHANGE IT IN: service-messaging/app/Http/Controllers/FormSubmissionController.php
          value: file,
        }
        // IMPORTANT!!
        files.push(fileObject)
      })
      return { data, files }
    },
  },
  watch: {
    additionalFilesGlobal(val) {
      this.previousFiles = val
    },
  },
  methods: {
    clearData() {
      ;(this.previousFiles = []), (this.additionalFilesGlobal = [])
    },
    removeItem(index) {
      this.additionalFilesGlobal.splice(index, 1)
    },
    fileAdded() {
      if (this.previousFiles.length > 0) {
        this.additionalFilesGlobal.push(...this.previousFiles)
      } else if (this.previousFiles.length < 0) {
        this.additionalFilesGlobal = this.previousFiles
      }
    },
  },
}
</script>
<style lang="scss" module>
.fixUploadRowWidth {
  max-width: 100%;
  margin: 0 auto;
}

.v-file-input__text {
  flex-direction: column;
  align-items: self-start;
}

.hubspotFileInput {
  padding: 16px 0;
}
</style>
